import axios from 'axios';

const authHttpClient = axios.create({
  baseURL: process.env.NEXT_PUBLIC_JAIMY_AUTH_API_URI,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

const rikHttpClient = axios.create({
  baseURL: process.env.NEXT_PUBLIC_JAIMY_RIK_URI,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

const httpClient = axios.create({
  baseURL: process.env.NEXT_PUBLIC_JAIMY_API_URI,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

export { authHttpClient, httpClient, rikHttpClient };
